import React, { useEffect, useState } from 'react'
import { ApiEndpoints } from '../../helper/ApiEndpoints';
import ApiRequest from '../../helper/ApiRequest';
import { BaseUrl } from '../../helper/BaseUrl';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const adminCaseListEndpoint = ApiEndpoints.newCase.adminCaseList;
const asList = (value) => (Array.isArray(value) ? value : []);

export default function OnDemandWork({ filterData = "Taxi app", initialData }) {
  const [allData, setAllData] = useState(() => asList(initialData));


  const PrevArrow = ({ onClick }) => (
    <button className="custom-arrow custom-prev-arrow" onClick={onClick}>
      <FontAwesomeIcon icon={faArrowLeft} />
    </button>
  );

  const NextArrow = ({ onClick }) => (
    <button className="custom-next-arrow custom-arrow" onClick={onClick}>
      <FontAwesomeIcon icon={faArrowRight} />
    </button>
  );

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: false,

    centerMode: true,
    centerPadding: "0px",

    speed: 500,

    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,

    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };


  useEffect(() => {
    if (allData.length) return;

    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", adminCaseListEndpoint);
        const result = response.newcasestudys;
        setAllData(asList(result));
      } catch (error) {
        console.log(error);
      }
    };

    dataFetch();
  }, [allData.length]);

  const filteredData = allData?.filter((item) => item?.category_name?.toLowerCase() === filterData?.toLowerCase());

  return (
    <>
      {filteredData?.length >= 4 && (
        <section className="ondemand-work-area">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <h3 className="heading center-heading">Our <span className="gradiant-color">Work</span> in Action</h3>
                <p className="sub-heading">Every case study reflects the value of partnering with a top white label app development agency. We have built apps that  transform industries, inspire users, and drive unparalleled business outcomes.</p>
              </div>
            </div>
          </div>

          <div className="ondemand-work-slider-wrap">
            <Slider {...settings}>
              {filteredData?.map((box, ind) => (
                <div key={ind} className="casenew-box-wrap" style={{ backgroundColor: box?.listing_card_color }}>
                  <div className="row align-items-center ">
                    <div className="col-lg-7">
                      <div className="casenew-box-content">
                        <div className='casenew-logo-wrap-box'>
                          <img src={BaseUrl + box?.logo} alt={box?.alt_logo} className="img-responsive newcase-logo" />
                          <span className='case-card-title'>{box?.title}</span>
                        </div>
                        <p>{box?.brief.length > 230 ? box?.brief?.slice(0, 230) + "..." : box?.brief}</p>

                        <div>
                          <div>
                            <label>{box?.app_rating}/5</label>
                            <small>App Rating</small>
                          </div>
                          <div>
                            <label>{box?.app_downloads}</label>
                            <small>Downloads</small>
                          </div>
                          <div>
                            <label>{box?.app_operational_efficiency}</label>
                            <small>{box?.app_operational_efficiency_heading}</small>
                          </div>
                        </div>

                        <div>
                          {box?.googleplay &&
                            <a href={box?.googleplay} target='_blank'><img src="/assets/home/google-play.webp" alt="google play" className="img-responsive" /></a>
                          }
                          {box?.appstore &&
                            <a href={box?.appstore}><img src="/assets/home/app-store.webp" alt="app store" className="img-responsive" /></a>
                          }
                        </div>

                        <Link to={`/case-study/${box?.slug}`}>View Case Study <FontAwesomeIcon icon={faArrowRight} /></Link>
                      </div>
                    </div>

                    <div className="col-lg-5">
                      <div className="casenew-box-img">
                        <img src={BaseUrl + box?.thumbnail} alt={box?.alt_thumbnail} className="img-responsive" />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </section>
      )}
    </>
  )
}
